<template>
  <div class="paper-student-condition">
    <div class="main">
      <div class="main-cont-wrapper">
        <AppScrollbar style="height: 100%">
          <div class="main-cont">
            <TitleGroup title="筛选学籍年级" :bold="false">
              <el-form size="mini" label-width="150px" label-suffix="：">
                <el-form-item label="班级范围" required>
                  <CustomClassesChooser v-model="form.classNames" :fetch-params="{paperBatchId: paperBatchId}">
                    <template #default="{ open }">
                      <el-button type="text" icon="el-icon-plus" @click="open">选择可参与论文班级</el-button>
                    </template>
                  </CustomClassesChooser>
                </el-form-item>
              </el-form>
            </TitleGroup>
            <TitleGroup title="筛选规则" :bold="false">
              <el-form size="mini" label-width="150px" label-suffix="：">
                <el-form-item label="课程通过门数" class="required">
                  <el-radio-group v-model="limitPassCourse">
                    <el-radio :label="false">不限制</el-radio>
                    <el-radio :label="true">
                      <span>数量&emsp; ≥</span>
                      <span class="input_inner" @click.stop.prevent>
                        <el-input-number v-model="form.passCourseNum" controls-position="right" :precision="0" :step="1"
                          :min="1" :max="100" :disabled="!limitPassCourse">
                        </el-input-number>
                      </span>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="学费缴费情况" class="required">
                  <el-checkbox-group v-model="form.tuitionStatus">
                    <el-checkbox label="1">已缴费</el-checkbox>
                    <el-checkbox label="2">未缴费</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </TitleGroup>
          </div>
        </AppScrollbar>
      </div>
      <div class="footer">
        <el-button size="mini" type="primary" :loading="committing" @click="handleApply">{{ committing ? '筛选中...' :
          '确认条件并筛选'}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import TitleGroup from '../../../../../../widgets/custom/TitleGroup'
import CustomClassesChooser from '../../../custom/chooser/classes'
import objectUtils from '../../../../../../../util/objectUtils'
import Hint from '../../../../../../elements/Hint'
export default {
  name: 'PaperStudentCondition',
  props: {
    paperBatchId: {
      type: String,
      required: true
    }
  },
  components: {
    Hint,
    AppScrollbar,
    TitleGroup,
    CustomClassesChooser
  },
  data () {
    return {
      committing: false,
      limitPassCourse: false,
      form: {
        classNames: [],
        passCourseNum: undefined,
        tuitionStatus: []
      }
    }
  },
  methods: {
    handleApply () {
      let form = JSON.parse(JSON.stringify(this.form))
      if (!form.classNames.length) {
        this.$message.warning('请选择参与论文班级')
        return
      }
      if (this.limitPassCourse) {
        if (!objectUtils.hasValue(form.passCourseNum)) {
          this.$message.warning('请设置通过课程限制门数')
          return
        }
      }
      if (!form.tuitionStatus.length) {
        this.$message.warning('请设置学费缴费情况')
        return
      }
      if (!this.limitPassCourse) {
        form.passCourseNum = 0
      }
      this.$emit('to-step', 2, this.$extend({ paperBatchId: this.paperBatchId }, form))
    }
  }
}
</script>

<style lang="scss">
.paper-student-condition{
  height: 100%;
  & > .main{
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .main-cont-wrapper{
      flex: 1;
      height: 0;
      .main-cont {
        padding: 10px 50px 20px;
        box-sizing: border-box;
        background-color: #fff;
        .title-group {
          margin-top: 20px;
          border-bottom: 1px solid #ebeef5;
          padding-bottom: 10px;
          &:last-child {
            border-bottom: none;
          }
          & > .title {
            color: #303133;
          }
          & > .main {
            padding-top: 10px;
            .el-form {
              margin-top: 10px;
              .el-form-item {
                margin-bottom: 15px;
                &.required {
                  .el-form-item__label {
                    position: relative;
                    &:before {
                      content: '*';
                      position: absolute;
                      left: 2px;
                      color: #f56c6c;
                    }
                  }
                }
                .el-form-item__label {
                  color: #606266;
                  font-size: 12px;
                  text-align: left;
                  padding-left: 12px;
                  padding-right: 30px;
                  white-space: nowrap;
                }
                .el-form-item__content {
                  font-size: 12px;
                  .el-date-editor {
                    width: 260px;
                  }
                  .el-select {
                    width: 100%;
                    .el-select__tags {
                      .el-tag {
                        .el-select__tags-text {
                          color: #606266;
                        }
                      }
                    }
                  }
                  .el-radio-group {
                    .el-radio {
                      margin-right: 20px;
                      min-width: 72px;
                      .el-radio__label {
                        font-size: 12px;
                        .input_inner {
                          margin-left: 10px;
                          .el-input-number {
                            width: 70px;
                            .el-input-number__increase,
                            .el-input-number__decrease {
                              width: 18px;
                            }
                            .el-input__inner {
                              padding-left: 1px;
                              padding-right: 20px;
                            }
                          }
                        }
                      }
                    }
                  }
                  .el-checkbox-group {
                    .el-checkbox {
                      margin-right: 20px;
                      min-width: 72px;
                      .el-checkbox__label {
                        font-size: 12px;
                        .el-checkbox__label {
                          font-size: 12px;
                        }
                      }
                    }
                  }
                  .el-divider {
                    margin: 10px 0;
                    background: linear-gradient(to right, #ddd 0%, #ddd 70%, transparent 70%) repeat-x!important;
                    background-size: 14px 1px!important;
                  }
                  .tip-msg {
                    color: #303133;
                    font-size: 12px;
                    margin-bottom: 5px;
                  }
                }
              }
            }
          }
        }
      }
    }
    & > .footer{
      height: 52px;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 40px;
      padding-top: 10px;
      box-sizing: border-box;
      background-color: #fff;
      .el-button {
        min-width: 110px;
        padding: 7px 6px;
      }
    }
  }
}
</style>
